import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Col,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import EmptyStateVideo from './components/Video';
import LearnMoreLink from './components/LearnMoreLink';
import UnlockButton from './components/UnlockButton';

import { userHasFeature } from '../../helpers/Features';
import { getSetting } from '../../helpers/Settings';

const EmptyShareSettings = ({ handleNewItem }) => {
  const intl = useIntl();

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center">
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'Create reusable share templates' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({ defaultMessage: 'Skip enabling advanced share settings again and again with every link. Enable share templates to create reusable settings for personal use or create templates available for your entire team.' })}
        </div>
        <div>
          {userHasFeature('share-templates') ? (
            <>
              {getSetting('share_templates_user_create') && (
                <Button color="primary" className="mt-4" onClick={handleNewItem}>
                  {intl.formatMessage({ defaultMessage: 'Enable share templates ' })}
                </Button>
              )}
            </>
          ) : (
            <UnlockButton feature="share-templates" />
          )}
          <LearnMoreLink url="https://help.stockpress.co/en/articles/9810537-creating-share-templates" />
        </div>
      </Col>
      <EmptyStateVideo video="share-templates" />
    </div>
  );
};

EmptyShareSettings.propTypes = {
  handleNewItem: PropTypes.func,
};

EmptyShareSettings.defaultProps = {
  handleNewItem: () => { },
};

export default EmptyShareSettings;
